import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitCardHeader.module.scss'

interface ICockpitCardHeaderProps {
  /** What the card is, on its own line. */
  title: ReactNode
  /** What the card is showing right now — filters, scope, a count — under the title. */
  description?: ReactNode
  /** The card's own acts, drawn as `CockpitIconButton` chips on the right edge. */
  actions?: ReactNode
  className?: string
}

/**
 * The header a cockpit card wears: its name and, under it, what it currently shows on the left;
 * its acts as icon buttons on the right. The two sides never collide — the text column takes the
 * width the controls leave it, and the controls keep one row whatever the text under the title
 * runs to.
 */
export const CockpitCardHeader = ({
  title,
  description,
  actions,
  className,
}: ICockpitCardHeaderProps) => (
  <div className={cn(styles.root, className)}>
    <div className={styles.text}>
      <h3 className={styles.title}>{title}</h3>
      {/* Always rendered, even empty: the title then stands at the same height on every card,
          whether or not the card has a line under it. */}
      <div className={styles.description}>{description}</div>
    </div>
    {/* Always rendered, even with nothing in it: a header whose control row comes and goes would
        stand at two different heights across cards carrying the same two lines. */}
    <div className={styles.actions}>{actions}</div>
  </div>
)

CockpitCardHeader.displayName = 'CockpitCardHeader'
